/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 16:42:47
 * @LastEditTime: 2022-06-10 14:27:29
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/Domains/index.tsx
 */
import { Button, Form } from '@/src/components/Antd';
import { message } from 'antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  connect_domain,
  delete_domain,
} from '@/src/request/salesChannel/setting/domain';
import { NEW } from '@/src/tools/constant';
import { EnumStatus, RequestType } from '@/src/types/common/domain';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { InfoCircleFilled } from '@ant-design/icons';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { ActionType, columns } from '../config';
import css from '../css.module.less';

const { Item } = Form;
interface DomainsTableIProps {
  value?: any;
  onChange?: () => void;
  initPageData?: any;
  modalOp?: any;
  disabled?: boolean;
}
const DomainsTable = ModalHoc((props: DomainsTableIProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    initPageData,
    modalOp: { setShowModal, setModalTitle, setModalContent },
    disabled,
  } = props;
  const history = useHistory();
  const params: any = useParams();
  const { uuid: salesChannelUuid } = params;

  const connectedDomains = (value || []).filter(
    (o) => o.status == EnumStatus.Connected,
  );
  const otherDomains = (value || []).filter(
    (o) => o.status !== EnumStatus.Connected,
  );

  const handleGoToAdd = () => {
    history.push(`/salesChannel/setting/domain/${salesChannelUuid}/${NEW}`);
  };

  const handleGoToEdit = (domainUuid) => {
    history.push(
      `/salesChannel/setting/domain/${salesChannelUuid}/${domainUuid}`,
    );
  };

  const handleConnectDomain = (domainUuid) => {
    connect_domain(domainUuid).then((data) => {
      initPageData(RequestType.Domains);
    });
  };

  const handleDeleteDomain = (domainUuid) => {
    delete_domain(domainUuid).then((data) => {
      message.success(getI18n('general.savesuccess'));
      initPageData(RequestType.Domains);
    });
  };

  const handleConnectConfirm = (domainUuid) => {
    if (connectedDomains.length) {
      const otherDomain = (value || []).find((i) => i.uuid === domainUuid);
      const otherDomainName = otherDomain ? otherDomain?.domain : '';
      const connectedDomainName = connectedDomains[0]?.domain || '';

      setShowModal(true);
      setModalTitle('Connect Domain');
      setModalContent(
        <div>
          <p className={css.connectModal}>
            {replaceI18nVariables(
              getI18n('salesChannelDomainAndStatus.list.domainscontentModal'),
              otherDomainName,
              connectedDomainName,
            )}
          </p>
          <ModalFooter
            onOk={() => handleConnectDomain(domainUuid)}
            onCancel={() => setShowModal(false)}
            okText={getI18n('salesChannelDomainAndStatus.list.connect')}
          />
        </div>,
      );
    } else {
      handleConnectDomain(domainUuid);
    }
  };

  const handleDeleteDomainConfirm = (domainUuid) => {
    setShowModal(true);
    setModalTitle(
      <div className={css.modalHeader}>
        <InfoCircleFilled
          className={css.headerIcon}
          style={{ color: '#ff695f' }}
        />
        {getI18n('salesChannelDomainAndStatus.list.deleteDomain')}
      </div>,
    );

    setModalContent(
      <div>
        <p className={css.connectModal}>
          {getI18n('salesChannelDomainAndStatus.list.deleteModalContent')}
        </p>
        <ModalFooter
          onOk={() => handleDeleteDomain(domainUuid)}
          onCancel={() => setShowModal(false)}
          okText={getI18n('general.antd.Modal.ModalFooter.delete')}
          danger
        />
      </div>,
    );
  };

  const handleActionFun = (domainUuid, type: ActionType) => {
    const actionDo = {
      [ActionType.Edit]: handleGoToEdit,
      [ActionType.Connect]: handleConnectConfirm,
      [ActionType.Delete]: handleDeleteDomainConfirm,
    };
    actionDo[type](domainUuid);
  };

  return (
    <Fragment>
      <p className={css.domainsLabel}>
        {getI18n('salesChannelDomainAndStatus.list.connectedDomain')}
      </p>
      <Table
        id='domains'
        rowKey='uuid'
        columns={columns(handleActionFun, disabled, { getI18n })}
        dataSource={connectedDomains}
        pagination={false}
      />
      {otherDomains.length ? (
        <div className={css.otherDomains}>
          <p className={css.domainsLabel}>
            {getI18n('salesChannelDomainAndStatus.list.otherDomain')}
          </p>
          <Table
            id='domains'
            rowKey='uuid'
            columns={columns(handleActionFun, disabled, { getI18n })}
            dataSource={otherDomains}
            pagination={false}
          />
        </div>
      ) : null}

      <div className={css.buttonCombin}>
        <Button type='primary' onClick={handleGoToAdd} disabled={disabled}>
          {getI18n('salesChannelDomainAndStatus.list.addDomain')}
        </Button>
      </div>
    </Fragment>
  );
});

const Domains = ({ initPageData, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n('salesChannelDomainAndStatus.list.domains')}>
      <Item name='domains'>
        <DomainsTable initPageData={initPageData} disabled={disabled} />
      </Item>
    </SectionWrapper>
  );
};

export default Domains;
